import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=7806d39d&"
import script from "./TicketList.vue?vue&type=script&lang=ts&"
export * from "./TicketList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7806d39d')) {
      api.createRecord('7806d39d', component.options)
    } else {
      api.reload('7806d39d', component.options)
    }
    module.hot.accept("./TicketList.vue?vue&type=template&id=7806d39d&", function () {
      api.rerender('7806d39d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/tickets/TicketList.vue"
export default component.exports